<form [formGroup]="settingsForm" class="grid">
  <div class="col-6 flex flex-column">
    <div class="flex flex-column gap-2">
      <osp-form-field>
        <osp-label [tooltip]="settingsLimitExplanation">{{ settingsLimitLabel }}</osp-label>
        <osp-input-number
          [formControlName]="controlNames.SETTINGS_LIMIT"
          [maxFractionDigits]="inputMaxFractionDigits"
        />
        <osp-error
          [messages]="{
            required: 'shared.validation.requiredField' | translate,
            min: 'shared.validation.number.notNegative' | translate
          }"
        />
      </osp-form-field>
    </div>
  </div>

  @if (isIntervalFieldVisible) {
    <div class="col-6 flex flex-column">
      <div class="flex flex-column gap-2">
        <osp-form-field>
          <osp-label [tooltip]="settingsIntervalExplanation">{{ settingsIntervalLabel }}</osp-label>
          <osp-input-number
            [formControlName]="controlNames.SETTINGS_INTERVAL"
            id="limit-settings-interval"
            [min]="0"
            [format]="false"
            [maxLength]="7"
          />
          <osp-error
            [messages]="{
              required: 'shared.validation.requiredField' | translate,
              min: 'shared.validation.number.notNegative' | translate
            }"
          />
        </osp-form-field>
      </div>
    </div>
  }
</form>
